module.exports = __webpack_public_path__ + "static/bg-man-sitting-f72ef5bce8bc45fd81b9f28ec015b5f3.jpg";